import { create } from 'zustand';
import api from '../services/api';

/**
 * Store global de configurações do estabelecimento.
 * Layout carrega uma vez após login; Dashboard, Relatorios e outros
 * apenas lêem os flags sem fazer novas requisições.
 */
const useConfiguracaoStore = create((set, get) => ({
  configuracao: null,   // null = ainda não carregado
  carregando: false,
  carregada: false,
  erro: null,

  carregar: async ({ force = false } = {}) => {
    if (get().carregando) return;
    if (get().carregada && !force) return;
    set({ carregando: true });
    try {
      const res = await api.get('/configuracoes');
      const configuracao = res.data && Object.keys(res.data).length ? res.data : null;
      set({ configuracao, carregada: true, erro: configuracao ? null : 'Configuracao ausente' });
    } catch {
      set({ configuracao: null, carregada: true, erro: 'Falha ao carregar configuracao' });
    } finally {
      set({ carregando: false });
    }
  },

  // Limpa ao fazer logout
  limpar: () => set({ configuracao: null, carregada: false, erro: null }),

  // Helper: retorna false durante loading (evita módulos desabilitados aparecerem),
  // true se config não carregou mas não está carregando, ou se o módulo está ativo.
  moduloAtivo: (campo) => {
    const { configuracao, carregada } = get();
    if (!carregada || !configuracao) return false;
    return configuracao[campo] === true;
  },
}));

export default useConfiguracaoStore;
